<template>
<div>
   <div class="view mx-auto mt-5">
    </div>
</div>
</div>
</template>

<script>



export default {
   
    data () {
    return {
      
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/page5/preview.vue